import { gql } from '@apollo/client';

export const GET_ACTIVE_PROMOTION = gql`
  query GetActivePromotion {
    getActivePromotion {
      id
      source
      discountCode
      title
      description
      imageUrl
      imageFilename
      isActive
      accessDurationDays
      createdAt
      updatedAt
    }
  }
`;